import { useEffect, useState } from 'react';
import { getPlayerGuilds } from '../api';
import { Guild } from '../types';
import { useNavigate } from "react-router-dom";

export function useFetchPlayerGuild() {
  const [guilds, setGuilds] = useState<Guild[]>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    getPlayerGuilds()
    .then(({ data }) => {
      setGuilds(data);
    })
    .catch((err: any) => {
      console.log(err);
      navigate('/menu')
      setError(err);
    })
    .finally(() => setLoading(false))
  }, [navigate]);

  return { guilds, error, loading };
}